'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _megaNavLinks = require('./megaNavLinks');

var _urls = require('../../../utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AllAuctions = require('./AllAuctions');

var _AllAuctions2 = _interopRequireDefault(_AllAuctions);

var _propsComparer = require('../../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _components = require('../../../components');

var _LinkContainer = require('./LinkContainer');

var _LinkContainer2 = _interopRequireDefault(_LinkContainer);

var _MegaNavLink = require('./MegaNavLink');

var _MegaNavLink2 = _interopRequireDefault(_MegaNavLink);

var _noop = require('../../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Navigation = require('./Navigation.scss');

var _Navigation2 = _interopRequireDefault(_Navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Navigation = function (_Component) {
    (0, _inherits3.default)(Navigation, _Component);

    function Navigation(props, context) {
        (0, _classCallCheck3.default)(this, Navigation);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Navigation.__proto__ || (0, _getPrototypeOf2.default)(Navigation)).call(this, props, context));

        _this.setWrapper = function (node) {
            _this.wrapper = node;
        };

        _this.handleClickOutside = function (event) {
            if (_this.wrapper && !_this.wrapper.contains(event.target)) {
                _this.closeNav();
            }
        };

        _this.openNav = function (Key) {
            return function () {
                if (_this.props.hideDropdown) {
                    return;
                }
                _this.setState({ active: Key });
            };
        };

        _this.closeNav = function () {
            if (_this.state.active) {
                _this.setState({ active: 0 });
            }
        };

        _this.tabletNavigation = function (link, key) {
            return function () {
                if (_this.state.active !== key) {
                    _this.setState({ active: key });
                } else {
                    window.location.assign(link);
                    _this.setState({ active: 0 });
                }
            };
        };

        _this.state = {
            active: 0
        };
        return _this;
    }

    (0, _createClass3.default)(Navigation, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.mobile === 'tablet') {
                document.addEventListener('touchstart', this.handleClickOutside);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.mobile === 'tablet') {
                document.removeEventListener('touchstart', this.handleClickOutside);
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['baseUrl', 'mobile', 'parent']) || (0, _propsComparer2.default)(this.state, nextState, ['active']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                mobile = _props.mobile,
                parent = _props.parent;
            var active = this.state.active;

            var isPhone = mobile && mobile !== 'tablet';
            return _react2.default.createElement(
                'div',
                { className: _Navigation2.default.wrapper, ref: this.setWrapper },
                (0, _jsx3.default)('div', {
                    className: _Navigation2.default.navigation,
                    onMouseLeave: !mobile ? this.closeNav : _noop2.default
                }, void 0, (0, _jsx3.default)('div', {
                    className: _Navigation2.default['scroll-container']
                }, void 0, (0, _jsx3.default)(_components.Link, {
                    className: _Navigation2.default.item,
                    to: baseUrl + '/catalog/search?parameters=%7B%22page%22%3A1%2C%22pageSize%22%3A120%2C%22catalog_status%22%3A%22live%2Conline%22%7D'
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'today'
                })), (0, _jsx3.default)('div', {
                    className: _Navigation2.default.item + ' ' + _Navigation2.default.pipe
                }, void 0, '|'), (0, _jsx3.default)(_AllAuctions2.default, {
                    baseUrl: baseUrl,
                    parent: parent
                }), (0, _jsx3.default)('div', {
                    className: _Navigation2.default.item + ' ' + _Navigation2.default.pipe
                }, void 0, '|'), (0, _jsx3.default)('div', {
                    className: _Navigation2.default.navBar
                }, void 0, (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 1,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(1),
                    tabletNavigation: this.tabletNavigation('/c/art/1/', 1),
                    link: '/c/art/1/',
                    msgId: 'art'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 2,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(2),
                    tabletNavigation: this.tabletNavigation('/c/jewelry/6/', 2),
                    link: '/c/jewelry/6/',
                    msgId: 'jewelry'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 3,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(3),
                    tabletNavigation: this.tabletNavigation('/c/asian/158/', 3),
                    link: '/c/asian/158/',
                    msgId: 'asian_antiques'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 4,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(4),
                    tabletNavigation: this.tabletNavigation('/c/furniture/4/', 4),
                    link: '/c/furniture/4/',
                    msgId: 'furniture'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 5,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(5),
                    tabletNavigation: this.tabletNavigation('/c/collectibles/2/', 5),
                    link: '/c/collectibles/2/',
                    msgId: 'collectibles'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 6,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(6),
                    tabletNavigation: this.tabletNavigation('/c/home-garden/5/', 6),
                    link: '/c/home-garden/5/',
                    msgId: 'home_and_garden'
                }), (0, _jsx3.default)(_MegaNavLink2.default, {
                    active: active === 7,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    openNav: this.openNav(7),
                    tabletNavigation: this.tabletNavigation('/c/fashion/3/', 7),
                    link: '/c/fashion/3/',
                    msgId: 'fashion'
                }))), !isPhone && (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 1,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.art,
                    picLinkS: (0, _urls.getMegaNavImageUrlSmall)('art'),
                    picLinkL: (0, _urls.getMegaNavImageUrlLarge)('art')
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 2,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.jewelry,
                    picLinkS: (0, _urls.getMegaNavImageUrlSmall)('jewelry'),
                    picLinkL: (0, _urls.getMegaNavImageUrlLarge)('jewelry')
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 3,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.asian,
                    picLinkS: (0, _urls.getMegaNavImageUrlSmall)('asian'),
                    picLinkL: (0, _urls.getMegaNavImageUrlLarge)('asian')
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 4,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.furniture
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 5,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.collectibles,
                    picLinkS: (0, _urls.getMegaNavImageUrlSmall)('collectibles'),
                    picLinkL: (0, _urls.getMegaNavImageUrlLarge)('collectibles')
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 6,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.home
                }), (0, _jsx3.default)(_LinkContainer2.default, {
                    active: active === 7,
                    closeNav: this.closeNav,
                    mobile: mobile,
                    linkArray: _megaNavLinks.fashion
                })), (0, _jsx3.default)('div', {
                    className: _Navigation2.default.fade
                }))
            );
        }
    }]);
    return Navigation;
}(_react.Component);

exports.default = Navigation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation/Navigation.js
// module id = M7t3
// module chunks = 46